import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { CalendarClock } from "lucide-react";

/** Dashboard-Widget "MHD läuft ab". Klick führt gefiltert in den Tab "MHD & Ablauf". */
export default function ExpiryWidget() {
  const { t, fmtDate } = useI18n();
  const [d, setD] = useState(null);

  useEffect(() => { api.get("/inventory/expiry-summary").then((r) => setD(r.data)).catch(() => {}); }, []);

  const c = d?.counts || {};
  const tiles = [
    { key: "expired", value: c.expired || 0, cls: "text-destructive" },
    { key: "critical", value: c.critical || 0, cls: "text-destructive" },
    { key: "soon", value: c.soon || 0, cls: "text-amber-600" },
  ];

  return (
    <div className="rounded-md border border-border bg-card p-5 shadow-sm" data-testid="dash-expiry-widget">
      <h3 className="font-heading text-lg font-medium mb-1 flex items-center gap-2">
        <CalendarClock className="h-4 w-4" /> {t("ex.dashTitle")}
      </h3>
      <p className="mb-4 text-xs text-muted-foreground">{t("ex.dashSub")}</p>
      <div className="grid grid-cols-3 gap-2">
        {tiles.map((x) => (
          <Link key={x.key} to={`/lager?tab=mhd&status=${x.key}`} data-testid={`dash-expiry-${x.key}`}
            className="rounded-md border border-border p-3 text-center hover:bg-muted transition-colors">
            <div className={`font-mono text-xl font-semibold ${x.cls}`}>{x.value}</div>
            <div className="mt-1 text-xs text-muted-foreground">{t(`ex.status.${x.key}`)}</div>
          </Link>
        ))}
      </div>
      <div className="mt-4 space-y-2" data-testid="dash-expiry-upcoming">
        {(d?.upcoming || []).map((r, i) => (
          <Link key={i} to={`/lager?tab=mhd&status=${r.status}`}
            className="flex items-center justify-between rounded-md border border-border p-2 text-sm hover:bg-muted transition-colors"
            data-testid={`dash-expiry-lot-${i}`}>
            <span className="truncate pr-2">{r.product_name || r.sku}</span>
            <span className="shrink-0 font-mono text-xs text-muted-foreground">
              {fmtDate(r.best_before_date)} · {r.quantity}
            </span>
          </Link>
        ))}
        {d && !(d.upcoming || []).length && (
          <p className="text-sm text-muted-foreground" data-testid="dash-expiry-none">{t("ex.noRows")}</p>
        )}
      </div>
    </div>
  );
}
